// Producto contratado y rol profesional son conceptos distintos.
// Las tres membresías salen el 25-oct (decisión de Sebastián del 17-oct):
// `disponible` dice que la contratación está CONSTRUIDA. Que se pueda pagar
// lo decide aparte el interruptor del servidor (FLOW_CHECKOUT_ENABLED), que
// sigue apagado hasta que Sebastián lo encienda ese día.
// Los nombres son los de los Términos §6 y la página de precios (16-oct):
// un concepto, un nombre, en todas las superficies.
export const PRODUCTOS_PLUS = Object.freeze({
  plus_estudiante: { nombre: 'Estudiante Plus', modos: ['estudiante'], disponible: true },
  plus_enfermero: { nombre: 'Enfermero Plus', modos: ['enfermero'], disponible: true },
  full: { nombre: 'Full', modos: ['estudiante', 'enfermero', 'tens'], disponible: true },
});

// La invitación a las membresías en la web (auditoría de conversión del
// 25-oct-2026, pedido de Sebastián): la MISMA frase en cada puerta a Planes
// (Tu acceso, el aviso de la prueba, el tope de Benito y /precios). El botón
// que paga, ya dentro de Planes, nombra la membresía elegida ("Activar
// Enfermero Plus"): lo que se contrata se dice entero. Vive aquí y no en
// plan.js porque varias pruebas reemplazan plan.js con planGating y la
// frase desaparecería. Jamás en la app instalada (skill venta-solo-web).
export const CTA_MEMBRESIA = 'Activa tu membresía Plus';

// Cuando no se habla de una membresía en particular (un permiso antiguo sin
// producto, o un sello que no sabe de quién es), la palabra de los Términos.
export const MEMBRESIA_GENERICA = 'Membresía';

// El nombre de la membresía de esta persona: su producto, o la palabra
// genérica para un permiso antiguo o una prueba ("Las membresías contratadas
// antes del 25 de octubre mantienen su vigencia", Términos §6).
export function nombreMembresia(profile) {
  return PRODUCTOS_PLUS[profile?.premium_product]?.nombre || MEMBRESIA_GENERICA;
}

export function productoCubreModo(producto, modo) {
  return PRODUCTOS_PLUS[producto]?.modos.includes(modo) === true;
}

// Precios anunciados, confirmados por el fundador el 14-10-2026, y desde el
// 17-oct los que cobra el servidor (api/_shared/flow.js los lee de aquí).
// No modifican contratos ni planes existentes de Flow.
export const PRECIOS_ANUNCIADOS_CLP = Object.freeze({
  plus_estudiante: 7990,
  plus_enfermero: 10990,
  full: 13990,
});

// "$7.990": el precio de cara al usuario, igual en la app, el correo y /precios.
export function precioClp(monto) {
  return `$${Number(monto).toLocaleString('es-CL')}`;
}
